import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=6247781e&scoped=true&"
import script from "./UiButton.vue?vue&type=script&lang=ts&"
export * from "./UiButton.vue?vue&type=script&lang=ts&"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=6247781e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247781e",
  null
  
)

export default component.exports